module.exports = __webpack_public_path__ + "static/media/2.18.aeca3ae7.png";